import { render, staticRenderFns } from "./relevant-case-question.vue?vue&type=template&id=1131c510&scoped=true&"
import script from "./relevant-case-question.vue?vue&type=script&lang=js&"
export * from "./relevant-case-question.vue?vue&type=script&lang=js&"
import style0 from "./relevant-case-question.vue?vue&type=style&index=0&id=1131c510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131c510",
  null
  
)

export default component.exports